import { render, staticRenderFns } from "./teacherCat.vue?vue&type=template&id=5234058a&scoped=true&"
import script from "./teacherCat.vue?vue&type=script&lang=js&"
export * from "./teacherCat.vue?vue&type=script&lang=js&"
import style0 from "./teacherCat.vue?vue&type=style&index=0&id=5234058a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5234058a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
